export default __webpack_public_path__ + "static/assets/d4df8fdbedd0de7fc8e5a523985fef51.svg";